import { selectConfig } from "../features/config/ConfigSlice";
import { useSelector } from "react-redux";
import React from "react";

function OAGPromoLogo() {
  const { components } = useSelector(selectConfig);
  if (components.Images.OAGPromoLogo.display) {
    return (
      <a
        href={components.Images.OAGPromoLogo.link}
        target={components.Images.OAGPromoLogo.target}
      >
        <div className="oag-promo-logo" />
      </a>
    );
  } else {
    return null;
  }
}

export default OAGPromoLogo;
